
export const getInitials = (name, surname) => {
    let n1 = name ? name.trim() : null;
    let n2 = surname ? surname.trim() : null;
    if (n1 && n2) {
        return (n1[0] + n2[0]).toUpperCase()
    } else if (n1) {
        return n1[0].toUpperCase()
    } else if (n2) {
        return n2[0].toUpperCase()
    }

    return '-'
}